import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Costcenters} from '../costcenters';
import {CostcentersService} from '../costcenters.service';
import {ActivatedRoute, Router , NavigationEnd} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {TreeNode} from 'primeng/api';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TreeModule} from "primeng/tree";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {stringify} from "@angular/compiler/src/util";
import {Item} from "../../../../model";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {CurrencyMaskModule} from "ng2-currency-mask";

@NgModule({
    imports: [CommonModule, FormsModule, TreeModule, DropdownModule,MessagesModule,MyInputsModule,CurrencyMaskModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        CostcentersShowComponent
    ],
    entryComponents: [
        CostcentersShowComponent
    ],
    exports: [],
    providers: [SharedService, CostcentersService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-costcenters-show',
    templateUrl: './costcenters-show.component.html',
    styleUrls: ['./costcenters-show.component.scss'],
    providers: [CostcentersService, ConfirmationService, MessageService]
})

export class CostcentersShowComponent implements OnInit, AfterViewInit {
    id: string;
    costcenters = new Costcenters();
    applog: AppLogComponent;
    @Input() delId;
    @Input() scrId;
    @Input() oldData;
  @Input() newData;
  @Input() newDatap;
  @Input() newDatad;

  @Input() modelName;
  @Input() allow2action = true;

    modalRef: NgbModalRef;
    parent:any;
    form: FormGroup;
    group: any[] = [];
    tree: TreeNode[];
    item: Item;

    name: string;
    private sub: any;
    msgs: Message[] = [];
  Classification_costcenter_arr: any[] =[
    {'val':1,'title':'Branch'},{'val':2,'title':'Employee'},{'val':3,'title':'Project'},{'val':4,'title':'Others'}
  ];

  costcenter_nature_arr: any[] = [
    {'val':1,'title':'Debt'},{'val':2,'title':'Credit'},{'val':3,'title':'Both'}
  ];
  final_costcenter_arr: any[] = [
    {'val':1,'title':'Budget'},{'val':2,'title':'Profit and loss'},{'val':3,'title':'Trade'}
  ];
    private _saveButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private costcentersService: CostcentersService,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private modalService: NgbModal,
                private confirmationService: ConfirmationService,
                private messageService: MessageService) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata && userdata.lang) {
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setItemShow(CostcentersShowComponent);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},


        ]);
        this.sharedservice.setModelName('costcenters');


    }
    showParent() {
        if(this.parent) {

            const options: NgbModalOptions = {

                beforeDismiss: () => {
                    console.log('before dismiss');
                    return true;
                }
            };
            this.modalRef = this.modalService.open(CostcentersShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                // this.changePicUrl();
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.costcenters;
        modalRef.componentInstance.rowId = '';

    }
    ngAfterViewInit() {
      if(!this.scrId && !this.newData) {

            this._saveButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if (this._saveButton) {
                this._saveButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/costcenters/edit', this.id]);
                });
            }
            if (this._deleteButton) {
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteCostcenters(this.costcenters);
                });
            }
            if (this._newButton) {

                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/costcenters']);
                });
            }
            if (this._searchButton) {
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/costcenters/search']);
                });
            }
        }
    }

    ngOnInit() {
      this.router.routeReuseStrategy.shouldReuseRoute = function(){
        return false;
      };

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          this.router.navigated = false;
          window.scrollTo(0, 0);
        }
      });

      const msg = JSON.parse(localStorage.getItem('showMessages'));
      if (msg) {
        localStorage.removeItem('showMessages');
        this.msgs = msg;
      }
        this.costcentersService.getAllCostcenters().subscribe(
            group => {
                this.group = group;
            });
        this.costcentersService.getTree('0').then(tree => this.tree = tree);
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}, Validators.required),
          name: new FormControl({value: '', disabled: true}, [Validators.required]),
          master_costcenter_id: new FormControl({value: '', disabled: true}),
          costcenter_nature: new FormControl({value: '', disabled: true}, Validators.required),
          Classification_costcenter: new FormControl({value: '', disabled: true}, Validators.required),
          sub_costcenter_expected: new FormControl({value: '', disabled: true}, Validators.required),
          max_credit: new FormControl({value: '', disabled: true}, Validators.required),
          max_debit: new FormControl({value: '', disabled: true}, Validators.required),
          final_costcenter: new FormControl({value: '', disabled: true}, Validators.required)

        });

        if (this.id) {
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;

            this.delId = false;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
                this.msgs = [];
            }
            this.costcentersService.getById(this.id).subscribe(
                costcenters => {
                    this.id = costcenters.id;
                    this.costcenters = costcenters;
                    this.parent = costcenters.p_group_id;
                    this.form.patchValue({
                        id: costcenters.id,
                        name: costcenters.name,
                      master_costcenter_id: costcenters.master_costcenter_id,
                      costcenter_nature: costcenters.costcenter_nature,
                      Classification_costcenter: costcenters.Classification_costcenter,
                      sub_costcenter_expected: costcenters.sub_costcenter_expected,
                      final_costcenter: costcenters.final_costcenter,
                      max_credit: costcenters.max_credit,
                      max_debit: costcenters.max_debit,
                    });

                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.scrId) {
            //this.activeModal.dismiss('');

            this.oldData = false;
            this.newData = false;

            this.delId = false;

            this.costcentersService.getById(this.scrId).subscribe(
                costcenters => {
                    this.id = costcenters.id;
                    this.costcenters = costcenters;
                    this.form.patchValue({
                        id: costcenters.id,
                      name: costcenters.name,
                      master_costcenter_id: costcenters.master_costcenter_id,
                      costcenter_nature: costcenters.costcenter_nature,
                      Classification_costcenter: costcenters.Classification_costcenter,
                      sub_costcenter_expected: costcenters.sub_costcenter_expected,
                      final_costcenter: costcenters.final_costcenter,
                      max_credit: costcenters.max_credit,
                      max_debit: costcenters.max_debit,
                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        if (this.delId) {
            this.oldData = false;
            this.newData = false;
            this.costcentersService.getTrashedById(this.delId).subscribe(
                costcenters => {
                    this.id = costcenters.id;
                    this.costcenters = costcenters;
                    this.form.patchValue({
                        id: costcenters.id,
                        name: costcenters.name,
                      master_costcenter_id: costcenters.master_costcenter_id,
                      costcenter_nature: costcenters.costcenter_nature,
                      Classification_costcenter: costcenters.Classification_costcenter,
                      sub_costcenter_expected: costcenters.sub_costcenter_expected,
                      final_costcenter: costcenters.final_costcenter,
                      max_credit: costcenters.max_credit,
                      max_debit: costcenters.max_debit,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if (this.oldData && this.newData) {
            this.costcenters = this.newData;
          // this.allow2action = false;
          this.newDatap = true;


          console.log(this.newDatap);
          console.log(this.newDatad);

            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
              master_costcenter_id: this.newData.master_costcenter_id,
              costcenter_nature: this.newData.costcenter_nature,
              Classification_costcenter: this.newData.Classification_costcenter,
              sub_costcenter_expected: this.newData.sub_costcenter_expected,
              final_costcenter: this.newData.final_costcenter,
              max_credit: this.newData.max_credit,
              max_debit: this.newData.max_debit,
            });
        }
    }
    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button) {
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('fin.costcenters.'+role) >= 0) {
            return true;
        }
        return false;
    }

    nodeSelect(_id: string) {
        this.costcentersService.getById(_id).subscribe(
            costcenters => {

                this.costcenters = costcenters;
                this.form.patchValue({
                    id: costcenters.id,
                    name: costcenters.name,
                    master_costcenter_id: costcenters.master_costcenter_id,
                    costcenter_nature: costcenters.costcenter_nature,
                    Classification_costcenter: costcenters.Classification_costcenter,
                    sub_costcenter_expected: costcenters.sub_costcenter_expected,
                    final_costcenter: costcenters.final_costcenter,
                  max_credit: costcenters.max_credit,
                  max_debit: costcenters.max_debit,
                  });
              }, error => {
                  console.log(error);
              }
        );
    }

    addnew(_id: string) {
        this.router.navigate(['/costcenters', _id]);
    }

    deleteCostcenters(costcenters: Costcenters) {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if (costcenters) {
                    this.costcentersService.delete(costcenters.id).subscribe(
                        res => {
                          let serv = 'success';
                          let messag = 'Delete completed';
                          if(res.result){
                            serv = 'success';
                            messag = 'Delete completed';
                          }else{
                            serv = 'error';
                            messag = 'Can not delete parent costcenter or costcenters used in other screen';
                          }
                            this.msgs = [];
                            this.msgs.push({
                                severity: serv,
                                summary: '',
                                detail: this.translate.instant(messag)
                            });
                            setTimeout(()=> {
                                this.router.navigate(['/costcenters']);
                            },1000);
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                            window.scroll(0,0);
                        }
                    );
                }
            }
        });
    }

    recoverEdit(costcenters: Costcenters) {
      console.log(costcenters);
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if (costcenters) {
                    this.costcentersService.update(costcenters).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');

                            this.router.navigate(['/costcenters/show', costcenters.id]);

                        }
                    );
                }
            }
        });
    }

    undotrashed() {
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if (this.delId) {
                    this.costcentersService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted item recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/costcenters/list']);
                        }
                    );
                }
            }
        });
    }



  showattachement(row_id: string) {
    if (row_id) {
      const options: NgbModalOptions = {

        beforeDismiss: () => {
          // this.changePicUrl();
          return true;
        }
      };
      const modalRef = this.modalService.open(AppArcComponent, options);
      modalRef.componentInstance.rowId = row_id;
      modalRef.componentInstance.screenName = this.modelName;
    }
  }
  showHistory(row_id: string) {
    if (row_id) {
      const modalRef = this.modalService.open(AppLogComponent);
      modalRef.componentInstance.rowId = row_id;
        modalRef.componentInstance.refShow = CostcentersShowComponent;

    }
  }



}



// WEBPACK FOOTER //
// ./src/app/views/fin/costcenters/costcenters-show/costcenters-show.component.ts